<template>
  <!--  <div class="customTabWrapper">-->
  <!--    <div class="tabItem pt-0">-->
  <!--      <div class="tabItem__inner">-->
  <section class="find d-none">
    <div class="find__header">
      <h2 class="find__title">Найдите ближайший офис</h2>
    </div>
    <div class="find__inner">
      <div class="find__icon">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path
              d="M14.6667 25.3333C20.5577 25.3333 25.3333 20.5577 25.3333 14.6667C25.3333 8.77563 20.5577 4 14.6667 4C8.77563 4 4 8.77563 4 14.6667C4 20.5577 8.77563 25.3333 14.6667 25.3333Z"
              stroke="#F94237" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round"/>
          <path d="M28.0002 28.0002L22.2002 22.2002" stroke="#F94237"
                stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      </div>
      <p class="find__text">
        Введите название Вашего населенного пункта для поиска ближайшего офиса
        NOVAROLL:
      </p>
      <form action="#" @submit.prevent="" class="find__form">
        <v-text-field
            placeholder="Поиск"
            flat
            solo

            v-model="search_query"
            hide-details
            class="find__input"
            :class="noMatchesFound ? 'noMatchesFound':''"
            ref="theInput"
        ></v-text-field>

        <button class="find__button" @click="find__button">Найти</button>


      </form>

      <!--hiddenMap-->
      <div id="map" class="d-none" style="width: 600px; height: 400px"></div>
      <!--hiddenMap end-->

      <!--===== Block with search results =====-->
      <div class="find__res position-relative w-100" v-if="result_nearest">
        <button class="call__close" @click="close_search()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </button>
        <h4 class="find__subtitle" v-if="!noMatchesFound">Ближайший офис:</h4>
        <h4 class="find__subtitle" v-if="noMatchesFound">Главный офис:</h4>
        <div class="find__box">
          <span class="find__city" v-if="result_nearest.title">{{ result_nearest.title }}</span>
          <span class="find__city" v-else>г. {{ result_nearest.name }}</span>
          <div class="find__contact">
            <div class="find__call copyEl">
              <a :href="result_nearest.phone_tel" class="find__link link">{{ result_nearest.phone }}</a>
              <span class="copyData">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                             stroke="#C0C0C0" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M25.3334 9.3335H13.3334C11.8607 9.3335 10.6667 10.5274 10.6667 12.0002V24.0002C10.6667 25.4729 11.8607 26.6668 13.3334 26.6668H25.3334C26.8062 26.6668 28.0001 25.4729 28.0001 24.0002V12.0002C28.0001 10.5274 26.8062 9.3335 25.3334 9.3335Z"
                                stroke="inherit" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round"/>
                            <path
                                d="M9.33325 21.3333H7.99992C7.29267 21.3333 6.6144 21.0524 6.1143 20.5523C5.6142 20.0522 5.33325 19.3739 5.33325 18.6667V6.66667C5.33325 5.95942 5.6142 5.28115 6.1143 4.78105C6.6144 4.28095 7.29267 4 7.99992 4H19.9999C20.7072 4 21.3854 4.28095 21.8855 4.78105C22.3856 5.28115 22.6666 5.95942 22.6666 6.66667V8"
                                stroke="inherit" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
            </div>
            <div class="find__mail copyEl">
              <a :href="result_nearest.email_mailto" class="find__link link">{{ result_nearest.email }}</a>
              <span class="copyData">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                             stroke="#C0C0C0" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M25.3334 9.3335H13.3334C11.8607 9.3335 10.6667 10.5274 10.6667 12.0002V24.0002C10.6667 25.4729 11.8607 26.6668 13.3334 26.6668H25.3334C26.8062 26.6668 28.0001 25.4729 28.0001 24.0002V12.0002C28.0001 10.5274 26.8062 9.3335 25.3334 9.3335Z"
                                stroke="inherit" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round"/>
                            <path
                                d="M9.33325 21.3333H7.99992C7.29267 21.3333 6.6144 21.0524 6.1143 20.5523C5.6142 20.0522 5.33325 19.3739 5.33325 18.6667V6.66667C5.33325 5.95942 5.6142 5.28115 6.1143 4.78105C6.6144 4.28095 7.29267 4 7.99992 4H19.9999C20.7072 4 21.3854 4.28095 21.8855 4.78105C22.3856 5.28115 22.6666 5.95942 22.6666 6.66667V8"
                                stroke="inherit" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
            </div>
          </div>
          <div class="find__data">
            <p class="find__subtext" v-html="result_nearest.workhours"></p>
            <p class="find__subtext find__address" v-html="result_nearest.address"></p>
          </div>
        </div>
      </div>
      <!--===== Block with search results =====-->
    </div>
  </section>
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->
</template>

<script>
import {debounce} from "../../debounce";

export default {
  name: "searchNearestOffice",
  props: {
    // page: String | Number | Boolean | Object,
    // sefdetail: String | Number | Boolean | Object,
    cities: String | Number | Boolean | Object,

  },
  data() {
    return {
      result_nearest: null,
      search_query: null,
      // search_result: false,
      search_start: false,
      defaultCoords: [55.73, 37.75],
      noMatchesFound: false,
    };
  },
  methods: {
    initMap(coords = [55.73, 37.75]) {
      var VueObject = this;
      let cityName = "Москва";
      console.log("ИЗ initMap:" + coords);

      ymaps.ready(init);
      var curCoordinates = coords;

      $.each(VueObject.cities, function (index, value) {
        VueObject.cities[index].geometry.coordinates = [VueObject.cities[index].properties.latitude, VueObject.cities[index].properties.longitude];
        //console.log(value);
        //console.log(VueObject.cities[index]);
      });

      function init() {
        // console.log(curCoordinates);
        // console.log(typeof curCoordinates);
        console.log(VueObject.cities+"cities");
        $("#map").html("");
        var map = new ymaps.Map("map", {
          center: curCoordinates,
          zoom: 7
        }); // Установили центр карты в выбранный город
        var result = ymaps.geoQuery({
          type: 'FeatureCollection',
          // features: <? print_r(str_replace(array("\"[", "]\""), array("[", "]"), json_encode($arCities))); ?>
          features: VueObject.cities,
        }).addToMap(map);
        // Запилили точки на карту
        console.log(result);
        result.then(function () {
          console.log("HERE");
          var closestObject = result.getClosestTo(curCoordinates);
          console.log(closestObject);
          console.log("THERE");
          /*var posText = document.getElementById("positionText");
          posText.innerHTML = closestObject["properties"]["_data"]["balloonContent"] +
          ". tel: " + closestObject["properties"]["_data"]["phone"] + ". address: " + closestObject["properties"]["_data"]["address"];
          console.log(posText);*/
          if (closestObject) {
            if (parseInt(closestObject["properties"]["_data"]["id"]) > 0) {
              $.ajax({
                "type": "POST",
                "url": "/ajax/nearest_city_show.php",
                "data": {"cityID": closestObject["properties"]["_data"]["id"], "ajaxPost": "Y"},
                "success": function (result) {
                  VueObject.result_nearest = JSON.parse(result);
                  console.log(VueObject.result_nearest);
                  console.log(VueObject.result_nearest.name);

                  /*if (Object.keys(VueObject.result_nearest).length == 0) {
                    VueObject.noMatchesFound = true;
                  }*/

                },
                "error": function (xhr, ajaxOptions, thrownError) {
                  console.log(xhr.status);
                  console.log(thrownError);
                }
              });
            }
            closestObject.balloon.open(); // Находим и отрываем ближайшую
            console.log(closestObject["properties"]["_data"]);
            console.log(closestObject["properties"]["_data"]["balloonContent"]);
          }
        });
      }
    },
    find__button() {
      var VueObject = this;

      if (this.search_query !== null) {
        this.search_start = true;
        $.ajax({
          "type": "POST",
          "url": "/ajax/nearest_city.php",
          "data": {"city_name": VueObject.search_query, "ajaxPost": "Y"},
          "dataType": "JSON",
          "success": function (result) {
            console.log(result);
            console.log(result.COORDS);
              if (result.LAT == 0 && result.LON == 0) {
                  VueObject.noMatchesFound = true;
              } else {
                  VueObject.initMap([result.LAT, result.LON]);
                  VueObject.noMatchesFound = false;
              }
          },
          "error": function (xhr, ajaxOptions, thrownError) {
            console.log(xhr.status);
            console.log(thrownError);
          },
        });
      } else {
        this.search_start = false;
      }
    },
    close_search() {
      this.result_nearest = null;
      this.noMatchesFound = false;
    },
  },
  watch: {
    search_query() {
      if (Object.keys(this.search_query).length == 0) {
        this.close_search();
      }
    }
  },
  created() {
    // this.initMap(this.defaultCoords);
  }
};
</script>

<style lang="scss">
@import "../../theme/_variable.scss";


</style>
<style lang="scss">
@import "../../theme/_variable.scss";

.customTabWrapper .find__input.v-input {
  padding: 6px 20px;
}

.find {

  .noMatchesFound.v-input {
    border: 1.2px solid #F94237;
    box-shadow: inset 0px 0px 2px rgb(0 0 0 / 12%);

    &:before {
      content: "Совпадений не найдено";
      position: absolute;
      top: -9px;
      left: 20px;
      width: max-content;
      background: #fff;
      padding: 2px 7px;
      z-index: 1;
      font-family: $RobotoRegular;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 100%;
      color: #F94237;
    }
  }

  & .find__res {
    & .call__close {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  & .v-text-field.v-text-field--solo .v-input__control {
    min-height: auto;
    padding: 0;
  }

  & .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot,
  & .v-text-field.v-text-field--enclosed .v-text-field__details {
    padding: 0;
  }

  & .search_popover__result {
    visibility: hidden;
    min-height: 0;
    padding: 10px 20px;
    // opacity: 0;
    & .search_popover_item {
      padding-top: 10px;
      padding-bottom: 10px;
      border-top: 0.5px solid #c4c4c4;
      transition: none !important;
      font-family: $RobotoLight;
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 20px;
      letter-spacing: 0.03em;
      color: #858585;

      &:first-child {
      }
    }

    &.active {
      visibility: visible;
      min-height: 70px;
      background: #fff;
      border-radius: 10px;
      margin-top: -22px;
      box-shadow: 0px 3px 7px rgb(0 0 0 / 10%);
      border-radius: 0 0 10px 10px;
      z-index: -1;
      position: relative;

      & .search_result {
        margin-top: 28px;
      }
    }
  }


}

</style>
